import { Component, Input, OnChanges, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { ClaimingStage } from './../../../api/models/claiming.models';
import { BusinessUnitCompleteness, BusinessData } from '@app/api/models/api-models';
import { Router } from '@angular/router';
import { timer, Subscription } from 'rxjs';

@Component({
  selector: 'progress-bar',
  templateUrl: 'progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  standalone: false,
})
export class ProgressBarComponent implements OnChanges {
  incomplete: string[];
  completeness: number;
  toComplete: number;
  id?: string;

  bussinesData: BusinessData;
  claimingStages = ClaimingStage;
  @Input() businessCompleteness: BusinessUnitCompleteness;
  @Input() claimingStage: ClaimingStage;
  @Input() previewMode: boolean;
  @Output() increaseHeightEmitter = new EventEmitter<boolean>();

  timerSubscription: Subscription;

  constructor(private router: Router) {}

  onClick() {
    this.router.navigate(['/main/profile']);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['businessCompleteness'] && this.businessCompleteness) {
      const { incomplete, id, completeness } = this.businessCompleteness;
      this.timerSubscription = this.increasedHeightTimer(incomplete);
      this.increasedHeightTimer(incomplete);
      this.timerSubscription.unsubscribe();
      if (incomplete.length > 3) {
        this.incomplete = incomplete.slice(0, 3);
      } else {
        this.incomplete = incomplete;
      }
      this.id = id;
      this.completeness = completeness;
      this.toComplete = Math.floor(100 - this.completeness);
    }
  }

  increasedHeightTimer(incomplete: string[]): Subscription {
    return timer(100).subscribe(() => {
      this.increaseHeightEmitter.emit(incomplete?.length > 1);
    });
  }
}
